// src/utils/uploadVideo.js
// Cloudinary par video upload (progress ke saath) + smooth playback ke liye
// optimized video / poster URLs.

// ⚠️ Yeh DONO values wahi hain jo tumhari src/utils/uploadImage.js mein hain.
// Wahan se copy karke yahan paste kar do (cloud name + unsigned upload preset).
// (Agar tumhari uploadImage.js .env use karti hai to yeh khud pick ho jayengi.)
const CLOUD_NAME =
  process.env.REACT_APP_CLOUDINARY_CLOUD_NAME ||
  process.env.REACT_APP_CLOUD_NAME ||
  "YOUR_CLOUD_NAME"; // <-- yahan apna Cloudinary cloud name likho
const UPLOAD_PRESET =
  process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET ||
  process.env.REACT_APP_UPLOAD_PRESET ||
  "YOUR_UPLOAD_PRESET"; // <-- yahan apna unsigned upload preset likho

export const MAX_VIDEO_MB = 100; // Cloudinary free plan: ek video ki max size ~100 MB

// Video upload. onProgress(0-100) se progress bar chalta hai.
export function uploadVideoToCloudinary(file, onProgress) {
  return new Promise((resolve, reject) => {
    if (CLOUD_NAME.startsWith("YOUR_") || UPLOAD_PRESET.startsWith("YOUR_")) {
      reject(
        new Error(
          "Cloudinary settings missing: src/utils/uploadVideo.js mein CLOUD_NAME aur UPLOAD_PRESET likho (uploadImage.js se copy karo)."
        )
      );
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", UPLOAD_PRESET);

    const xhr = new XMLHttpRequest();
    xhr.open("POST", `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/video/upload`);

    xhr.upload.onprogress = (e) => {
      if (e.lengthComputable && onProgress) {
        onProgress(Math.round((e.loaded / e.total) * 100));
      }
    };

    xhr.onload = () => {
      let data = {};
      try {
        data = JSON.parse(xhr.responseText);
      } catch (_) {}
      if (xhr.status >= 200 && xhr.status < 300 && data.secure_url) {
        resolve({ url: data.secure_url, publicId: data.public_id });
      } else {
        const msg = data.error?.message || "Video upload failed";
        reject(
          new Error(
            /api key|cloud_name/i.test(msg)
              ? msg + " — CLOUD_NAME galat hai (uploadImage.js wala cloud name copy karo)."
              : /preset/i.test(msg)
              ? msg + " — UPLOAD_PRESET galat hai, ya Cloudinary mein preset 'Unsigned' nahi hai."
              : msg
          )
        );
      }
    };

    xhr.onerror = () => reject(new Error("Network error while uploading video"));
    xhr.send(formData);
  });
}

// Smooth playback: MP4 (H.264, har browser/phone par chalta hai),
// auto quality, max width limit (bari video bhi halki ho jati hai)
export function optimizeVideoUrl(url, width = 1280) {
  if (!url || !url.includes("/upload/")) return url;
  return url
    .replace("/upload/", `/upload/vc_h264,q_auto,w_${width},c_limit/`)
    .replace(/\.[a-z0-9]+(\?.*)?$/i, ".mp4");
}

// Video ka pehla frame image ki tarah (poster) — jaldi load hota hai
export function videoPosterUrl(url, width = 800) {
  if (!url || !url.includes("/upload/")) return "";
  return url
    .replace("/upload/", `/upload/so_0,w_${width},c_limit,q_auto/`)
    .replace(/\.[a-z0-9]+(\?.*)?$/i, ".jpg");
}